import { render } from "./TestimonialCard.vue?vue&type=template&id=eff0fc9a&scoped=true"
import script from "./TestimonialCard.vue?vue&type=script&lang=js"
export * from "./TestimonialCard.vue?vue&type=script&lang=js"

import "./TestimonialCard.vue?vue&type=style&index=0&id=eff0fc9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eff0fc9a"]])

export default __exports__